import { render, staticRenderFns } from "./EditRiseupGoalAmount.vue?vue&type=template&id=6755750d&"
import script from "./EditRiseupGoalAmount.vue?vue&type=script&lang=js&"
export * from "./EditRiseupGoalAmount.vue?vue&type=script&lang=js&"
import style0 from "./EditRiseupGoalAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports